import React, {useState, useEffect, useRef, useMemo} from 'react';
import {Drawer, Form, Input, message, Space, Button} from 'antd';
import moment from 'moment';
import SPContact from '../SPContact';
import SPBookingTime from '../SPBookingTime';
import SPBusinessTime from '../SPBusinessTime';
import SPUploadPhotos from '../../../base/SPUploadPhotos';
import SPMap from '../../../base/SPMap';
import SPTitle from 'components/carRental/base/SPTitle';
import SPTag from 'components/base/SPTag';

import emiter, {
  EVENT_CARRENTAL_BRANCH_ADD,
  EVENT_CARRENTAL_UPDATE_WEBSITE_LIST,
  EVENT_CARRENTAL_BRANCH_VIEW,
  EVENT_CARRENTAL_ROLE_SEARCH_LIST
} from '../../../../events';

import { storeWebsiteAdd, getWebsiteDetail, storeWebsiteUpdate, storeWebsiteCheckName } from 'hooks/carRental/store';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';
import { API_VEHICLE_UPLOAD_PHOTO } from 'hooks/carRental/_';
import useModalCloseConfirm from 'hooks/base/modalCloseConfirm';
import {changeEnumToText} from "../../../../utils/tool";

interface PropsType {
  enums?: any;
  permission?: any;
}

const UPLOAD_SIZE = 10;


const getTag = (type: any, text: string) =>  {
  const tagsMap: any = {
    0: <SPTag type="processing" text={text} />,
    1: <SPTag type="success" text={text} />,
    2: <SPTag type="error" text={text} />
  }
  return tagsMap[type];
}

const SPBranchAddModal: React.FC<PropsType> = props => {
  const { permission, enums } = props;

  const [mainForm] = Form.useForm();

  const [type, setType] = useState<string>('');

  const storeInfo = useRef<any>({});
  const [disabled, setDisabled] = useState(false);
  const [actionBar, setActionBar] = useState(<></>);
  const websiteInfo = useRef<any>({});
  const [pageData, setPageData] = useState<any>(null);

  const { visible, onOpen, onClose, onOk, onEdited } = useModalCloseConfirm({});

  const handleOk = (callback: any) => {
    mainForm
      .validateFields()
      .then(values => {
        const formData = mainForm.getFieldsValue();

        const {
          website_name,
          position,
          pre_booking_time,
          address,
          business,
          website_imgs,
          contact_info_encrypt,
        } = formData || {};

        const { city_id, lng, lat } = position || {};
        const { time: least_pre_booking_time, unit: least_pre_booking_time_unit } = pre_booking_time || {};
        const { time: business_time, openNightService, pickUpFee, returnFee } = business;
        const [startTime, endTime] = business_time;
        const emergencyMember = contact_info_encrypt.filter((item: any) => item.emergency);
        const noEmergencyMember = contact_info_encrypt.filter((item: any) => !item.emergency);
        const contactInfoEncrypt = encryptTextByAES(
          [...emergencyMember, ...noEmergencyMember].map((item: any) => item.contact).join(','),
        );
        const params: any = {
          store_code: storeInfo?.current?.store_code,
          website_name,
          contact_info_encrypt: contactInfoEncrypt,
          city_id,
          address,
          longitude: `${lng}`,
          latitude: `${lat}`,
          open_time: startTime.format('HH:mm'),
            end_time: endTime.format('HH:mm'),
          business_time,
          least_pre_booking_time,
          least_pre_booking_time_unit,
          website_imgs: (website_imgs || []).map((item: any) => item.file_addr),
        };

        if (openNightService) {
          params.night_pickup_fee = +pickUpFee * 100;
          params.night_return_fee = +returnFee * 100;
        }
        let requestMethod = storeWebsiteAdd;
        if (websiteInfo.current?.website_code) {
          params.website_code = websiteInfo.current?.website_code;
          requestMethod = storeWebsiteUpdate;
        }
        requestMethod(params).then((res: any) => {
          const { errno, errmsg } = res || {};
          if (errno === 0) {
            message.success('操作成功');
            if (callback) callback();
            emiter.emit(EVENT_CARRENTAL_UPDATE_WEBSITE_LIST, storeInfo?.current?.store_code);
          } else {
            message.error(errmsg || '操作失败');
          }
        });
      }).catch(() => {});
  };

  const AddActionBar = () => {
    return (
      <Space>
        <Button onClick={() => onClose({ callback: handleCancel })}>关闭</Button>
        <Button type="primary" onClick={() => onOk({ callback: handleOk })}>提交</Button>
      </Space>
    );
  };

  const handleCancel = () => {
    setPageData({});
    setDisabled(false);
    websiteInfo.current = 0;
  };

  const handleModelOpen = (info: any, wInfo?: any) => {
    setType('add');
    mainForm.resetFields();
    storeInfo.current = info;
    if (wInfo) {
      setType('edit');
      websiteInfo.current = wInfo;
      handleWebsiteDetailGet(wInfo.website_code);
    }
    if (info?.city_id) {
      mainForm.setFieldsValue({
        position: {
          city_id: info?.city_id,
          lng: +info?.longitude,
          lat: +info?.latitude,
        },
      });
    }
    setActionBar(<AddActionBar />);
    onOpen();
  };

  const handleModelView = (info: any, wInfo?: any) => {
    setType('view');
    onOpen();
    storeInfo.current = info;
      setDisabled(true);
    if (wInfo) {
      websiteInfo.current = wInfo;
      handleWebsiteDetailGet(wInfo.website_code);
    }
    setActionBar(<></>);
  };

  const mainFormFields = {
    websiteName: {
      name: 'website_name',
      label: '网点名称',
      required: true,
      message: '请输入网点名称',
      placeholder: '请输入网点名称',
    },
    contactInfo: {
      name: 'contact_info_encrypt',
      label: '联系方式',
      required: true,
      message: '联系方式错误!',
      placeholder: '请输入联系方式',
    },
    dingweixuanze: {
      name: 'position',
      label: '定位选择',
      required: true,
      message: '定位选择错误!',
      placeholder: '定位选择',
    },
    address: {
      name: 'address',
      label: '门店地址',
      required: true,
      message: '地址描述错误!',
      placeholder: '请输入地址描述',
    },
    leastPreBookingTime: {
      name: 'pre_booking_time',
      label: '最小提前预定时间',
      required: true,
      message: '请输入最小提前预定时间!',
      placeholder: '最小提前预定时间',
    },
    businessTime: {
      name: 'business',
      label: '营业时间',
      required: true,
      message: '营业时间错误!',
      placeholder: '营业时间',
    },
    websiteImgs: {
      name: 'website_imgs',
      label: '网点引导图片',
      required: false,
      message: '请上传网点引导图片!',
      placeholder: '请上传网点引导图片',
    },
  };

  const handleWebsiteDetailGet = (code: number) => {
    getWebsiteDetail({
      website_code: code,
    }).then((res: any) => {
      const { errno, data } = res || {};
      if (errno === 0) {
        setPageData(data)
        const {
          website_name,
          contact_info_encrypt,
          address,
          least_pre_booking_time,
          least_pre_booking_time_unit,
          commission,
          open_time,
          end_time,
          night_pickup_fee,
          night_return_fee,
          city_id,
          latitude,
          longitude,
          website_imgs,
        } = data || {};

        const fromData = {
          website_name,
          contact_info_encrypt: decryptTextByAES(contact_info_encrypt)
            .split(',')
            .map((item: string, index: number) => ({ contact: item, emergency: index === 0 })),
          address,
          pre_booking_time: { time: least_pre_booking_time, unit: least_pre_booking_time_unit },
          commission,
          business: {
            time: [moment(open_time, 'HH:mm'), moment(end_time, 'HH:mm')],
            openNightService: !!(night_pickup_fee || night_return_fee),
            pickUpFee: night_pickup_fee / 100,
            returnFee: night_return_fee / 100,
          },
          position: {
            city_id,
            lng: +longitude,
            lat: +latitude,
          },
          website_imgs,
        };
        mainForm.setFieldsValue(fromData);
      }
    });
  };

  const handleValuesChange = () => {
    onEdited();
  }

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_BRANCH_ADD, handleModelOpen);
    emiter.on(EVENT_CARRENTAL_BRANCH_VIEW, handleModelView);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_BRANCH_ADD)
      emiter.removeAllListeners(EVENT_CARRENTAL_BRANCH_VIEW)
    }
  }, []);

  const rejectionText = useMemo(() => {
    if (pageData) {
      const text = changeEnumToText({
        nameSpace: 'audit_status',
        value: pageData?.audit_status,
        enums: enums
      })
      const arr = pageData?.labels?.map((item: any) => item.configReason)
      const reason = arr?.join('、')
      return `${text} ${arr?.length ? `${reason}` : '' }`
    }
  }, [pageData, enums])

  const drawerTitle = () => {
    const titleMap: any = { view: '查看关联网点', 'edit': '编辑关联网点' }
    if (['view', 'edit'].includes(type)) {
      return (
        <>
          <span style={{ marginRight: 8 }}>{titleMap[type]}</span> {getTag(pageData?.audit_status, rejectionText || '')}
        </>
      )
    }
    if (type === 'add') return '新增关联网点';
    return ''
  }

  return (
    <Drawer
      title={drawerTitle()}
      width="70%"
      open={visible}
      onClose={() => onClose({ callback: handleCancel })}
      destroyOnClose extra={actionBar}>
      {/* {
        pageData?.audit_status === 0 || pageData?.audit_status === 2 ?
          <Alert message={<span style={{color: 'red'}}>{rejectionText}</span>} type="error" style={{ marginBottom: "20px" }} /> : null
      } */}
      <Form name="basic" labelCol={{ style: { width: '138px' } }} form={mainForm} disabled={disabled} autoComplete="off" onValuesChange={handleValuesChange}>
        <SPTitle title='基础信息' />
        <Form.Item
          label={mainFormFields.websiteName.label}
          name={mainFormFields.websiteName.name}
          validateTrigger="onBlur"
          rules={[
            { required: true },
            {
              validator(_, value, callback) {
        //         if (!value) {
        //           callback('请输入网点名称');
                //   return;
                // }
                if (websiteInfo.current?.website_name === value) {
                  callback();
                  return;
                }
                storeWebsiteCheckName({
                  store_code: storeInfo?.current?.store_code,
                  website_name: value,
                }).then(res => {
                  if (res?.data) {
                    callback();
                  } else {
                    callback('网点名称重复');
                  }
                }).catch(() => {
                  callback('网点名称重复');
                });
              },
            },
          ]}
        >
          <Input placeholder={mainFormFields?.websiteName.placeholder} maxLength={30} showCount />
        </Form.Item>
        <Form.Item
          name={mainFormFields.contactInfo.name}
          label={mainFormFields.contactInfo.label}
          rules={[
            {
              required: mainFormFields.contactInfo.required,
              message: mainFormFields.contactInfo.message,
            },
          ]}
        >
          <SPContact useInput={true} />
        </Form.Item>
        <Form.Item
          name={mainFormFields.dingweixuanze.name}
          label={mainFormFields.dingweixuanze.label}
          rules={[
            {
              required: mainFormFields.dingweixuanze.required,
              message: mainFormFields.dingweixuanze.message,
            },
          ]}
        >
          <SPMap plugins={['PoiSearch', 'CitySelect']} />
        </Form.Item>
        <Form.Item
          name={mainFormFields.address.name}
          label={mainFormFields.address.label}
          rules={[
            {
              required: mainFormFields.address.required,
              message: mainFormFields.address.message,
            },
          ]}
          help="用户到门店取还车时展示的地址"
        >
          <Input placeholder={mainFormFields.address.placeholder} maxLength={50} showCount />
        </Form.Item>
        <SPTitle title='服务信息' style={{ paddingTop: 12 }} />
        <Form.Item
          name={mainFormFields.leastPreBookingTime.name}
          label={mainFormFields.leastPreBookingTime.label}
          rules={[
            { required: true },
            {
              validator(_, value, callback) {
                if (value && !value.time) {
                  callback(mainFormFields.leastPreBookingTime.message);
                  return;
                }
                callback();
              },
            },
          ]}
        >
          <SPBookingTime placeholder={mainFormFields.leastPreBookingTime.placeholder} max={99} />
        </Form.Item>
        <Form.Item
          name={mainFormFields.businessTime.name}
          label={mainFormFields.businessTime.label}
          rules={[
            {
              required: mainFormFields.businessTime.required,
              message: mainFormFields.businessTime.message,
            },
          ]}
        >
          <SPBusinessTime />
        </Form.Item>
        {/* <SPTitle title='网点图片信息' />
        <div style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.65)' }}>
          <p>1.仅支持jpg、jpeg、png格式的图片，长宽均不可超过2000px（最优比例2:1），{UPLOAD_SIZE}M以内;</p>
          <p>2.不可上传手机截屏，以及含有清晰人脸、电话、二维码、第三方水印、LOGO的图片</p>
        </div>
        <Form.Item
          name={mainFormFields.websiteImgs.name}
          label={mainFormFields.websiteImgs.label}
          rules={[
            {
              required: mainFormFields.websiteImgs.required,
              message: mainFormFields.websiteImgs.message,
            },
          ]}
        >
          <SPUploadPhotos accept=".jpg,.jpeg,.png" action={API_VEHICLE_UPLOAD_PHOTO} fileSize={UPLOAD_SIZE} hideTitle />
        </Form.Item> */}
      </Form>
    </Drawer>
  );
};

export default SPBranchAddModal;
